var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetappReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.getapp{fill:url(#getapp-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "getapp-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#87f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#40e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009c9c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "getapp",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M77.87674,48.7114l-15.09853-15.09846c-.71167-.71167-1.86546-.71167-2.57713,0l-1.07874,1.07874,10.81434,10.8144c1.20041,1.20034,1.86145,2.79632,1.86145,4.49391s-.66104,3.29357-1.86138,4.49384l-10.8144,10.8144,1.07874,1.07881c.71167.71167,1.86546.71167,2.57713,0l15.09853-15.09853c.7116-.71167.7116-1.86546,0-2.57713Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M66.73144,48.7114l-15.09853-15.09846c-.7116-.71167-1.86546-.71167-2.57713,0l-1.42313,1.42313,10.47002,10.47002c1.20041,1.20034,1.86145,2.79632,1.86145,4.49391s-.66104,3.29357-1.86138,4.49384l-10.47009,10.47009,1.42313,1.42313c.71167.71167,1.86553.71167,2.57713,0l15.09853-15.09853c.71167-.71167.71167-1.86546,0-2.57713Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M54.89743,48.7114l-15.09853-15.09846c-.7116-.71167-1.86546-.71167-2.57713,0l-15.09846,15.09846c-.71167.71167-.71167,1.86546,0,2.57713l15.09846,15.09853c.71167.71167,1.86553.71167,2.57713,0l15.09853-15.09853c.71167-.71167.71167-1.86546,0-2.57713ZM46.8523,48.77172l-3.0335,3.28741.5218,4.44259c.11399.97063-.87843,1.69178-1.76627,1.28334l-4.06403-1.86906-4.06389,1.86906c-.88784.40844-1.8804-.31271-1.76641-1.28334l.52187-4.44259-3.0335-3.28741c-.6627-.71824-.28359-1.88496.67473-2.07649l4.38642-.87657,2.18916-3.90093c.47823-.85222,1.70499-.85222,2.18335,0l2.18916,3.90093,4.38635.87657c.95839.19153,1.3375,1.35825.67473,2.07649Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetappReviewsScraper);
export default __webpack_public_path__ + "static/media/getapp-reviews-scraper.f8dfc9c1539961635d5fffdf6bcf1164.svg";
export { ForwardRef as ReactComponent };